import React from 'react';
import { injectIntl } from 'react-intl';
import { Form } from '@ant-design/compatible';
import { DeleteOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Input, Popconfirm, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import { TEMPLATE_MSG_PROGRAMMED_DEACTIVATION } from '../../../../constants/global';
import {
	getCalendarMessages,
	getClientMessages,
	getFields,
	getModalMessages,
	getPopConfirm,
} from '../../../../constants/messages';
import '@ant-design/compatible/assets/index.css';
const moment = require('moment');

let clientMessages = getClientMessages(),
	calendarMessages = getCalendarMessages(),
	fieldMessages = getFields(),
	modalMessages = getModalMessages(),
	popConfirmMessages = getPopConfirm();

const messages = {
	...clientMessages,
	...calendarMessages,
	...fieldMessages,
	...modalMessages,
	...popConfirmMessages,
};

class ProgrammedDeactivationForm extends React.Component {
	getIntl = (str, values = {}) => this.props.intl.formatMessage({ ...messages[str] }, values);

	disabledDates = (current) => {
		return current < moment().startOf('day');
	};

	formatPaidDateEventValue = (date) => {
		if (!date) return null;
		const momentAtTwelve = moment(date).set({ hour: 12, minute: 0, second: 0, millisecond: 0 });
		return momentAtTwelve;
	};

	renderDatePickerField = () => {
		const { props, getIntl, formatPaidDateEventValue, disabledDates } = this;
		const {
			form: { getFieldDecorator },
			disableDate,
		} = props;

		return (
			<Form.Item label={getIntl('programmedDeactivationDate')}>
				{getFieldDecorator(`date`, {
					initialValue: disableDate ? moment(disableDate).utc() : undefined,
					getValueFromEvent: formatPaidDateEventValue,
					rules: [
						{
							required: true,
							message: getIntl('programmedDeactivationDateError'),
						},
					],
				})(
					<DatePicker
						className="job-full-component"
						showTime={false}
						format={'DD-MM-YYYY'}
						allowClear
						showToday={false}
						disabledDate={disabledDates}
					/>
				)}
			</Form.Item>
		);
	};

	handleCommandChange = (commandSelected, option) => {
		if (commandSelected) {
			this.props.form.setFieldsValue({ comment: option.label });
		}
	};

	renderTemplateField = () => {
		const { props, getIntl, handleCommandChange } = this;
		const {
			form: { getFieldDecorator },
			comment,
		} = props;
		const templateOptions = TEMPLATE_MSG_PROGRAMMED_DEACTIVATION.map((template) => ({
			label: template,
			value: template,
		}));
		return (
			<Form.Item label={getIntl('template')}>
				{getFieldDecorator(`template`, {
					initialValue: comment ? TEMPLATE_MSG_PROGRAMMED_DEACTIVATION[0] : undefined,
					rules: [
						{
							required: true,
							message: getIntl('programmedDeactivationTemplateError'),
						},
					],
				})(<Select className="job-full-component" onChange={handleCommandChange} options={templateOptions} />)}
			</Form.Item>
		);
	};

	renderCommentField = () => {
		const { props, getIntl } = this;
		const {
			form: { getFieldDecorator, getFieldValue },
			comment,
		} = props;
		const currentTemplate = getFieldValue('template');

		return (
			<Form.Item label={getIntl('comment')}>
				{getFieldDecorator(`comment`, {
					initialValue: comment ? comment : undefined,
					rules: [
						{
							required: true,
							message: getIntl('programmedDeactivationMessageError'),
						},
					],
				})(<Input.TextArea showCount rows={3} maxLength={300} disabled={currentTemplate === undefined} />)}
			</Form.Item>
		);
	};

	handleSave = () => {
		const { props } = this;
		const {
			form: { validateFields },
			onSave,
		} = props;

		validateFields({ force: true }, (err, values) => {
			if (!err) {
				const { date, comment } = values;
				const isoDate = moment(date).toISOString();
				onSave(isoDate, comment);
			}
		});
	};

	handleDelete = () => {
		const {
			props: { form, onDelete },
		} = this;

		form.setFieldsValue({ date: undefined });
		form.setFieldsValue({ template: undefined });
		form.setFieldsValue({ comment: '' });
		onDelete();
	};

	renderSaveButton = () => {
		const {
			props: { isLoading, disableDate, comment, form },
			getIntl,
			handleSave,
			handleDelete,
		} = this;
		const { getFieldValue } = form;
		const currentComment = getFieldValue('comment');
		const currentDate = getFieldValue('date');
		const disableEditButton = currentComment === comment && moment(currentDate).isSame(disableDate, 'day');

		if (disableDate) {
			return (
				<Row type="flex" justify="space-between" align="middle">
					<Col span={11}>
						<Popconfirm
							title={getIntl('programmedDeactivationDateChangeConfirm')}
							onConfirm={handleSave}
							okText={getIntl('yes')}
							cancelText={getIntl('no')}
							disabled={disableEditButton}
						>
							<Button
								key="edit"
								disabled={disableEditButton}
								icon={<EditOutlined />}
								loading={isLoading}
								style={{ marginBottom: '10px' }}
								block={true}
								type="primary"
							>
								{getIntl('saveChanges')}
							</Button>
						</Popconfirm>
					</Col>
					<Col span={11}>
						<Popconfirm
							title={getIntl('programmedDeactivationDateClearConfirm')}
							onConfirm={handleDelete}
							okText={getIntl('yes')}
							cancelText={getIntl('no')}
						>
							<Button
								key="delete"
								icon={<DeleteOutlined />}
								loading={isLoading}
								style={{ marginBottom: '10px' }}
								block={true}
								danger
							>
								{getIntl('deleteProgrammedDeactivation')}
							</Button>
						</Popconfirm>
					</Col>
				</Row>
			);
		}
		return (
			<Button
				key="save"
				type="primary"
				block={true}
				loading={isLoading}
				onClick={handleSave}
				style={{ marginBottom: '10px' }}
				icon={<SaveOutlined />}
			>
				{getIntl('save')}
			</Button>
		);
	};

	render() {
		return (
			<Form layout="vertical" form={this.props.form}>
				{this.renderDatePickerField()}
				{this.renderTemplateField()}
				{this.renderCommentField()}
				{this.renderSaveButton()}
			</Form>
		);
	}
}

ProgrammedDeactivationForm.defaultProps = {
	disableDate: undefined,
};

ProgrammedDeactivationForm.propTypes = {
	intl: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
	disableDate: PropTypes.string,
	comment: PropTypes.string,
	onSave: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired,
};

export default Form.create()(injectIntl(ProgrammedDeactivationForm));
